import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { MARKUP_TYPE } from '@trnsact/business-criteria/dist/src/models/rule-event/aftermarket/markup-type';
import { FactBooleanType, FactNumericType, FactStringType, ProductConfig } from '../types';

export const initialConfigRow: ProductConfig = {
  cost: {
    value: 0,
    isUseRateFactor: false,
  },
  markup: {
    type: MARKUP_TYPE.PERCENTAGE,
    value: 0,
  },
  criteria: null,
  pricing: {
    min: 0,
    max: 0,
  },
  retailPrice: 0,
};

const factNamesNumeric: FactNumericType[] = Object.keys(FACT_NAMES_NUMERIC).map(key => ({
  value: FACT_NAMES_NUMERIC[key as keyof typeof FACT_NAMES_NUMERIC],
  label: key
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b(\w)/g, char => char.toUpperCase()),
}));

const factNamesBoolean: FactBooleanType[] = Object.keys(FACT_NAMES_BOOLEAN).map(key => ({
  value: FACT_NAMES_BOOLEAN[key as keyof typeof FACT_NAMES_BOOLEAN],
  label: key
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b(\w)/g, char => char.toUpperCase()),
}));

const factNamesString: FactStringType[] = Object.keys(FACT_NAMES_STRING).map(key => ({
  value: FACT_NAMES_STRING[key as keyof typeof FACT_NAMES_STRING],
  label: key
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b(\w)/g, char => char.toUpperCase()),
}));

export const allAftermarketProductsTypes = [...factNamesNumeric, ...factNamesBoolean, ...factNamesString];
